//angular
import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
//app
import { AppAnimations } from 'src/app/_shared/animations';
import { CompanyIntegrationModel, RestResponse } from 'src/app/_shared/models';
import { LoaderService } from 'src/app/_core/services';
import { SharedIntegrationService } from 'src/app/_core/services/api/shared-integration.service';
import { IntegrationStatus, VisibleState} from 'src/app/app.data';
import { KeyName } from 'src/app/app.keynames';
import { MetaService } from 'src/app/_core/services/meta.service';
import { Unsubscriber } from 'src/app/_shared/unsubscriber/unsubscriber';

@Component({
  animations: [AppAnimations],
  selector: 'app-dialog-link-subscription',
  templateUrl: './link-subscription.component.html',
  styleUrls: ['./link-subscription.component.scss']
})

export class DialogLinkSubscriptionComponent implements OnInit, OnDestroy {
  collectionOfCompanyIntegration: Array<CompanyIntegrationModel> = [];
  form: FormGroup;
  formSubmitted: boolean = false;
  integrationId: number;
  isProductReady: boolean = false;
  options: any;
  variant: any;
  linkThisToAllChargesId = false;

  private subs = new Unsubscriber();

  @Input() _visibleState = VisibleState;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    private _dialogRef: MatDialogRef<DialogLinkSubscriptionComponent>,
    private _fb: FormBuilder,
    private _loader: LoaderService,
    public _meta: MetaService,
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer,
    private sharedIntegrationService: SharedIntegrationService,
  ) {
    this._iconRegistry.addSvgIcon('ico-info', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-help-faq.svg'));
    this._iconRegistry.addSvgIcon('ico-check-01', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-check-01.svg'));
    this._iconRegistry.addSvgIcon('ico-check', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-check-01.svg'));
    this._iconRegistry.addSvgIcon('ico-close', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-01.svg'));
    this._iconRegistry.addSvgIcon('ico-del-item', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-close-03.svg'));
    this._iconRegistry.addSvgIcon('ico-search', this._sanitizer.bypassSecurityTrustResourceUrl('assets/svg/ico-search-01.svg'));
  }

  getCompanyIntegrationsByChannelName(channelName: string) {
    this.subs.addSub = this.sharedIntegrationService.getCompanyIntegrationsByChannelName(channelName).subscribe(
      (res:RestResponse) => {
        this.collectionOfCompanyIntegration = (<Array<CompanyIntegrationModel>>res.data).filter(ci => ci.status == IntegrationStatus.active);
        if (this.integrationId) {
          this.form.get('companyIntegration').setValue(this.collectionOfCompanyIntegration.find(ci => ci.id == this.integrationId));
        }
      },
      (err:RestResponse) => {
        this._meta.showNotification(err);
      }
    );
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }

  ngOnInit() {
    this.setUpForm();
    if (this._data.integrationId) {
      this.integrationId = this._data.integrationId;
    }

    this.getCompanyIntegrationsByChannelName(this._data.integrationKeyName);
  }

  onClose(): void {
    this._dialogRef.close({ code: KeyName.form_invalid });
  }

  onCompanyIntegrationChange(_companyIntegration: CompanyIntegrationModel) {
    this.form.get('companyIntegration').setValue(_companyIntegration);
    this.integrationId = _companyIntegration.id;
    this.isProductReady = false;
  }

  onSubmit() {
    this.formSubmitted = !this.formSubmitted;
    let formValidation = this.form.invalid;

    if (formValidation) {
      this.formSubmitted = !this.formSubmitted;
      this.form.markAllAsTouched();
      this.form.markAsDirty();
      return;
    }


    let res: any = {
      code: KeyName.form_submitted,
      integrationId: this.integrationId,
    };
    this._loader.startPageLoader();
    this._dialogRef.close(res);
  }


  setUpForm() {
    this.form = this._fb.group({
      companyIntegration: ['', [Validators.required]],
    });
  }
}
